<template>
  <div class="reports">
    <template v-if="tableItems.length">
      <p class="h3">Список жалоб</p>

      <AppTable
        :fields="tableFields"
        :items="tableItems"
        class="reports__table"
        @sort="onSortTable"
      >
        <template #object="{ id, title }">
          <BaseLink :href="`reports/${id}`">
            {{ title }}
          </BaseLink>
        </template>
      </AppTable>

      <div
        v-if="(paginationTotal / paginationPerPage) > 1"
        class="reports__pag-wrapper"
      >
        <AppPagination
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
        />
      </div>
    </template>

    <p v-else class="h3">Список жалоб пуст.</p>
  </div>
</template>

<script>
import AppPagination from '@/components/Base/AppPagination'
import AppTable from '@/components/AppTable'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'reportsPage',
  components: {
    BaseLink,
    AppTable,
    AppPagination
  },
  data () {
    return {
      tableFields: [
        { key: 'object', label: 'Объект жалобы', slot: true },
        { key: 'count', label: 'Количество жалоб' },
        { key: 'type', label: 'Тип жалобы', sortable: true }
      ],
      tableItems: [],
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 101,
      order: 'DESC',
      sort: 'id'
    }
  },
  computed: {
    /**
     * Тело запроса
     */
    requestBody () {
      return {
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        sort: this.sort,
        order: this.order
      }
    }
  },
  watch: {
    paginationCurrent: 'fetchReports'
  },
  async created () {
    await this.fetchReports()
  },
  methods: {
    async fetchReports () {
      try {
        const { data } = await this.$api.report.list(this.requestBody)
        let reports = data?.list ?? []

        reports = reports.map(item => {
          const type = item?.type?.label ?? ''
          const count = item?.count ? item?.count : 0
          const id = item?.id ?? {}
          const title = item?.title ?? {}

          return { type, count, id, title }
        })

        /* Записал общее колво жалоб */
        this.paginationTotal = data.pages * this.paginationPerPage
        this.tableItems = reports
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchReports()
    }
  }
}
</script>

<style lang="scss" scoped>
.reports {
  &__table {
    margin-top: 20px;
  }

  &__pag-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
